import { Link } from "@mui/material";
import { ContentTitle, MainContainer, MainContent } from "./common/components/Layout";
import { useTranslation } from "react-i18next";

/**
 * ヘルプ画面のコンポーネントです。
 *
 * @returns ヘルプ画面のコンポーネント
 */
export const HelpPage = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <MainContainer>
      <MainContent>
        <ContentTitle>{t("help.applicationInfoTitle")}</ContentTitle>
        <div className="flex flex-col items-center">
          <Link href="oss_license.txt" target="_blank" rel="noopener">
            {t("help.ossLicenseInfoLink")}
          </Link>
        </div>
      </MainContent>
    </MainContainer>
  );
};
